import sum from "lodash/sum";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  franchiseUsers: [],
  franchiseUser: null,
  franchiseAllUser: [],
};

const slice = createSlice({
  name: "franchiseUser",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getfranchiseUsersSuccess(state, action) {
      state.isLoading = false;
      state.franchiseUsers = action.payload;
    },

    getfranchiseUserSuccess(state, action) {
      state.isLoading = false;
      state.franchiseUser = action.payload;
    },
    getfranchiseAllUserSuccess(state, action) {
      state.isLoading = false;
      state.franchiseAllUser = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

export function getfranchiseUsers(franchiseId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const resolvedFranchiseId =
        franchiseId?.id || franchiseId?._id || franchiseId;
      if (!resolvedFranchiseId || typeof resolvedFranchiseId !== "string") {
        throw new Error("Franchise ID is missing");
      }

      const response = await axios.get(`${backendUrl}/franchiseUser`, {
        params: {
          franchiseId: resolvedFranchiseId,
          limit: 9999999999999,
        },
      });
      dispatch(slice.actions.getfranchiseUsersSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



// ----------------------------------------------------------------------

export function getfranchiseUser(franchiseUserId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/franchiseUser/${franchiseUserId}`
      );
      dispatch(slice.actions.getfranchiseUserSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllUsersOffranchise(franchiseId, getToken) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/franchiseUsers/getAllfranchiseUsers?&limit=${9999999999999}`,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
          params: {
            franchise: franchiseId,
          },
        }
      );
      dispatch(slice.actions.getfranchiseAllUserSuccess(response.data?.results));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
